// extracted by mini-css-extract-plugin
export default {"hiddenContainerSmall":"hiddenContainerSmall__NGJmM","visibleContainerSmall":"visibleContainerSmall__MjJmM"};